import { LOCALES, useLocale, useLocaleStore, useT } from "../i18n/index.js";

/** Nút VI / EN — HQ-2026-006. Lưu ở `localStorage["hq-locale"]`, đổi là cả app render lại. */
export function LocaleSwitch() {
  const t = useT("shell");
  const locale = useLocale();
  const setLocale = useLocaleStore((s) => s.setLocale);
  return (
    <div role="group" aria-label={t("language")} className="flex rounded border p-0.5 text-xs">
      {LOCALES.map((l) => (
        <button
          key={l}
          type="button"
          aria-pressed={locale === l}
          onClick={() => setLocale(l)}
          className={`rounded px-2 py-0.5 font-medium uppercase ${
            locale === l ? "bg-foreground text-background" : "hover:bg-foreground/5"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
